var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    {
      staticClass: "mx-0 mb-8 pl-0 pt-0",
      attrs: {
        id: "projects-list",
        fluid: "",
        "data-cy": "projects-list-container",
      },
    },
    [
      _vm.displaySkeleton
        ? _c("SSkeletonTable", {
            attrs: { "data-cy": "projects-skeleton", headers: _vm.headers },
          })
        : _c("v-data-table", {
            staticClass: "remove-box-shadow projects-table",
            attrs: {
              "data-cy": "projects-list-table",
              headers: _vm.headers,
              items: _vm.projectsInPage,
              "hide-default-footer": "",
              "disable-pagination": "",
            },
            on: { "click:row": _vm.onRowClick },
            scopedSlots: _vm._u([
              {
                key: "item.name",
                fn: function ({ item }) {
                  return [
                    _c(
                      "td",
                      {
                        staticClass: "ellipsis",
                        attrs: { "data-cy": "projects-list-name-cell" },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "pl-1",
                            attrs: { "data-cy": "projects-list-name" },
                          },
                          [
                            _vm._v(
                              "\n          " + _vm._s(item.name) + "\n        "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "item.initDate",
                fn: function ({ item }) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "ellipsis",
                        attrs: { "data-cy": "projects-list-initDate" },
                      },
                      [
                        _vm._v(
                          "\n        " + _vm._s(item.initDate) + "\n      "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "item.companyCif",
                fn: function ({ item }) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "ellipsis",
                        attrs: { "data-cy": "projects-list-companyId" },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.getCompanyName(item.companyCif)) +
                            "\n      "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "item.members",
                fn: function ({ item }) {
                  return [
                    _c(
                      "span",
                      { attrs: { "data-cy": "projects-list-vertical" } },
                      [
                        _vm._v(
                          " (" + _vm._s(_vm.getMembers(item.members)) + ") "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "item.hide",
                fn: function ({ item }) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "status-container",
                        attrs: { "data-cy": "projects-status-cell" },
                      },
                      [
                        _c("SLabel", {
                          staticClass: "text-body-3 p-1 pl-3 pr-3",
                          attrs: { "data-cy": "projects-status-label" },
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
      _vm._v(" "),
      !_vm.displaySkeleton
        ? _c(
            "div",
            {
              staticClass: "pagination-container",
              attrs: { "data-cy": "projects-pagination" },
            },
            [
              _c("SPagination", {
                attrs: {
                  itemsPerPage: _vm.ITEMS_PER_PAGE,
                  totalItems: _vm.projects.length,
                  onPageChange: _vm.onPageChange,
                  "data-cy": "projects-spagination",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }